import type { FC } from 'react';
import type { WellEurMetrics } from 'types/api-responses';
import { WellEurStrip } from 'components/well-cards';
import { WorkspaceCard, type WellScope } from 'components/workspace-cards';

interface Props {
  eur?: WellEurMetrics | null;
  scope: WellScope;
}

/**
 * The workspace's EUR card — the shared strip in the workspace card frame.
 * @param {Props} props The scoped well's EUR figures and the card's well stepper.
 * @return {JSX.Element} The card.
 */
export const WellEurCard: FC<Props> = ({ eur, scope }) => (
  <WorkspaceCard title="EUR" scope={scope}>
    <WellEurStrip eur={eur} />
  </WorkspaceCard>
);
